import script from "./Talent.vue?vue&type=script&setup=true&lang=ts"
export * from "./Talent.vue?vue&type=script&setup=true&lang=ts"

import "./Talent.vue?vue&type=style&index=0&id=3f60e03e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f60e03e"]])

export default __exports__